import { IChatEntity } from '../interfaces/chat-entity.interface';
import { IInboxFilter } from '../interfaces/inbox-filter.interface';

export const chatFilter = (chat: IChatEntity, filter: IInboxFilter) => {
  if (!filter) {
    return true;
  }

  // search filtering
  const { searchTerm, dateRange, orderBy, chatExceptions } = filter;
  const isIncluded =
    chatExceptions.length === 0
      ? true
      : chatExceptions.includes(chat.channelProvider);

  const identity = chat.externalCustomerIdentity
    ? chat.externalCustomerIdentity.toLowerCase()
    : '';
  const fullName = chat.user.fullName ? chat.user.fullName.toLowerCase() : '';
  const search = searchTerm ? searchTerm.trim().toLowerCase() : '';

  const isSearchExist = search
    ? identity.includes(search) || fullName.includes(search)
    : true;

  // date range filtering
  const isDateRangeExist = Object.values(dateRange).every(Boolean);
  const { field } = orderBy;
  const { fromDate, toDate } = dateRange;
  const dateA = chat[field] as string;
  const dateB = chat[field] as string;
  const isDateRangeCovered = isDateRangeExist
    ? new Date(dateA).valueOf() > fromDate && new Date(dateB).valueOf() < toDate
    : true;

  return isSearchExist && isDateRangeCovered && isIncluded;
};
